let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bopMY")).then(() => parcelRequire('cz07p'));